import star from '@/assets/img/pennant/star.png'
import emptyStar from '@/assets/img/pennant/empty_star.png'
import reputationBg from '@/assets/img/pennant/reputationBg.png'
import deleteIcon from '@/assets/img/pennant/delete.png'
import archive from '@/assets/img/pennant/archive.png'
import extIcon from '@/assets/img/pennant/ext.png'
const defaultFeedbackTypeMap = [
  {
    label: '点赞',
    value: 1,
    num: 0,
    key: 'likeCount'
  },
  {
    label: '锦旗',
    value: 2,
    num: 0,
    key: 'pennantCount'
  },
  {
    label: '感谢信',
    value: 3,
    num: 0,
    key: 'letterCount'
  },
  {
    label: '评价',
    value: 4,
    num: 0,
    key: 'commentCount'
  }
]
const evaluateColumns = [
  {
    label: '评价人',
    key: 'evaluatorName'
  },
  {
    label: '评价时间',
    key: 'evaluateTime'
  },
  {
    label: '评价星级',
    key: 'score',
    customRender: 'score'
  },
  {
    label: '评价状态',
    key: 'evaluateStatusString'
  },
  {
    label: '评价内容',
    key: 'content'
  }
]
const drawerWrapStyle = {
  background: `url(${reputationBg})`,
  backgroundSize: '100% 120px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top',
  padding: '0px'
}
const headerStyle = {
  background: 'transparent'
}
export {
  defaultFeedbackTypeMap,
  evaluateColumns,
  star,
  emptyStar,
  drawerWrapStyle,
  headerStyle,
  deleteIcon,
  archive,
  extIcon
}
